import Breakpoints from 'breakpoints-js/src/breakpoints';

//https://github.com/amazingSurge/breakpoints-js
const breakpoints = {

    device: {
        DESKTOP: 'desktop',
        TABLET:  'tablet',
        MOBILE:  'mobile'
    },

    breakpointsValue: {
        mob:  '768',
        tab:  '1152'
    },

    init() {
        Breakpoints({
            mobile:  {
                min: 1,
                max: breakpoints.breakpointsValue.mob
            },
            tablet:  {
                min: breakpoints.breakpointsValue.mob,
                max: breakpoints.breakpointsValue.tab
            },
            desktop: {
                min: breakpoints.breakpointsValue.tab,
                max: Infinity
            }
        });
    },

    manualBreakpoints(size) {
        //Breakpoints has problem with .current() when called immediately
        if (size < breakpoints.breakpointsValue.mob) {
            return 'mobile'
        }

        if (size >= breakpoints.breakpointsValue.mob && size < breakpoints.breakpointsValue.tab) {
            return 'tablet'
        }

        if (size >= breakpoints.breakpointsValue.tab) {
            return 'desktop'
        }
    }
};

window.breakpoints = breakpoints;

breakpoints.init();

export default breakpoints;
